const reviewsArr = [
  {
    title: "Лучшие тренера!!!",
    date: "02.09.2025",
    mainText: "Индивидуальный подход к каждому ребенку. Рекомендую 👍",
    linkUrl:
      "https://yandex.ru/maps/org/164337193121/reviews?reviews%5BpublicId%5D=z4qyzhn7fnrfarghz25dwzu6wg&si=37wpbdw3z78zngaw14htr0xg6c&utm_source=review",
  },
  {
    title: "Замечательные тренеры!",
    date: "22.09.2024",
    mainText: "Прогоны на позитиве, лучший клуб танцев города Воронеж.",
    linkUrl:
      "https://yandex.ru/maps/org/agon/164337193121/reviews/?ll=39.178738%2C51.653561&tab=reviews&utm_source=review&z=14.49",
  },
  {
    title: "Лучшая школа бальных танцев Воронежа!",
    date: "25.08.2023",
    mainText:
      "В клубе Агон, отличные учителя, ребенка многому научили, виден результат. Спасибо Садчиковым П.В.и А.О. за их труд!",
    linkUrl:
      "https://yandex.ru/maps/org/164337193121/reviews?reviews%5BpublicId%5D=puw0aekek6jvffjx7pxcu6kk8c&si=37wpbdw3z78zngaw14htr0xg6c&utm_source=review",
  },
  {
    title: "Занимаемся в клубе несколько лет.",
    date: "25.08.2023",
    mainText:
      "Хочется отметить удобное расположение клуба, высокий  профессиональный и культурный уровень педагогического состава.",
    linkUrl:
      "https://yandex.ru/maps/org/agon/164337193121/reviews/?ll=39.178738%2C51.653561&tab=reviews&utm_source=review&z=14.49",
  },
  {
    title: "Отличный клуб!",
    date: "29.08.2022",
    mainText:
      "Клуб Агон - это то место, где ты не только учишься танцевать, но и взрослеешь нравственно. Для многих учеников клуб Агон, это второй дом. Дети друг друга поддерживают, болеют на соревнованиях, поддерживают в трудную минуту. Тренера применяют лояльные методики, в игровой форме проводят занятия для младших групп.",
    linkUrl:
      "https://yandex.ru/maps/org/164337193121/reviews?reviews%5BpublicId%5D=p3tk94x4b5trw2e9a2vrpevuqg&si=37wpbdw3z78zngaw14htr0xg6c&utm_source=review",
  },
  {
    title: "Отличная школа!",
    date: "10.08.2022",
    mainText: `Агон - это отличная школа для Спортивно бальных танцев!! Это грандиозная, единая работа талантливых тренеров, во главе с Павлом Валерьевичем  Садчиковым!! Это занятия, которые дают нашим детям заряд бодрости, тренируют выносливость, и эмоциональную энергию!! Очень рады тренироваться, воспитываться и развиваться в Танцевально Спортивном Клубе " АГОН " !!!!. Спасибо всем тренерам!!`,
    linkUrl:
      "https://yandex.ru/maps/org/164337193121/reviews?reviews%5BpublicId%5D=32nbqu16u006dmzfz9cemr4th4&si=37wpbdw3z78zngaw14htr0xg6c&utm_source=review",
  },
];

const reviewsSlider = new Swiper(".reviews__field", {
  spaceBetween: 20,
  autoplay: true,
  breakpoints: {
    0: {
      slidesPerView: 1,
    },
    600: {
      slidesPerView: 2,
    },
    900: {
      slidesPerView: 2,
    },
    1100: {
      slidesPerView: 3,
    },
  },
});

reviewsArr.forEach((el) => {
  $(".reviews__field .swiper-wrapper").append(`
        <div class="review swiper-slide">
            <p class="review__title">${el.title}</p>
            <p class="review__date">${el.date}</p>
            <p class="review__description">${el.mainText}</p>
            <a href="${el.linkUrl}" target="_blank" class="review__button">
                Читать отзыв в источнике
                <div class="review__button-arrow">
                    <img src="../../../img/arrow-up-right.svg" />
                </div>
            </a>
        </div>
    `);
});

$(".reviews__top-thumbs .arrow.prev").on("click", () => {
  reviewsSlider.slidePrev();
});

$(".reviews__top-thumbs .arrow.next").on("click", () => {
  reviewsSlider.slideNext();
});
